import { render, staticRenderFns } from "./myTicketsPC.vue?vue&type=template&id=0efd2645&scoped=true"
import script from "./myTicketsPC.vue?vue&type=script&lang=js"
export * from "./myTicketsPC.vue?vue&type=script&lang=js"
import style0 from "./myTicketsPC.vue?vue&type=style&index=0&id=0efd2645&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efd2645",
  null
  
)

export default component.exports